import { render } from "./AccountPreferences.vue?vue&type=template&id=66bed5c9"
import script from "./AccountPreferences.vue?vue&type=script&lang=js"
export * from "./AccountPreferences.vue?vue&type=script&lang=js"

import "./AccountPreferences.vue?vue&type=style&index=0&id=66bed5c9&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__